export default {"src":"https://cdn.jetlend.ru/_next/static/media/header-menu-arrow--mobile.7a872243.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};